import React, { useState, useEffect } from 'react';
import { TOKENS } from '../tokens';
import api from '../api/client';
import { Plus, Users, LayoutDashboard, CheckSquare } from 'lucide-react';

export function ProjectsScreen({ onNavigate }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const { data } = await api.get('/projects');
      setProjects(data.data || data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ margin: 0, fontFamily: 'Fraunces', color: TOKENS.navyDeep }}>Projects</h2>
        <button style={{
          background: TOKENS.gold, color: TOKENS.navyDeep, 
          border: 'none', padding: '10px 16px', borderRadius: 8, 
          fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer'
        }}>
          <Plus size={18} /> New Project
        </button>
      </div>

      {loading ? (
        <p>Loading projects...</p>
      ) : projects.length === 0 ? (
        <div style={{ background: '#fff', padding: 40, borderRadius: 16, textAlign: 'center', color: '#666' }}>
          <LayoutDashboard size={48} style={{ opacity: 0.2, marginBottom: 16 }} />
          <h3>No projects found</h3>
          <p>Create a project to start managing tasks and deliveries.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 20 }}>
          {projects.map(p => (
            <div 
              key={p.project_id} 
              onClick={() => { if (onNavigate) onNavigate('pm_tasks'); }}
              style={{
                background: '#fff', borderRadius: 16, padding: 20,
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)', border: '1px solid #eee',
                cursor: 'pointer'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                <span style={{ 
                  background: p.health === 'Green' ? '#E6F4EA' : p.health === 'Amber' ? '#FEF7E0' : '#FCE8E6',
                  color: p.health === 'Green' ? '#1E8E3E' : p.health === 'Amber' ? '#B06000' : '#D93025',
                  padding: '4px 8px', borderRadius: 12, fontSize: 12, fontWeight: 600
                }}>
                  {p.health || 'Green'}
                </span>
                <span style={{ fontSize: 12, color: '#888', fontWeight: 600 }}>{p.stage}</span>
              </div>
              <h3 style={{ margin: '0 0 4px 0', color: TOKENS.navyDeep, fontSize: 18 }}>{p.name}</h3>
              <p style={{ margin: 0, color: '#666', fontSize: 14 }}>Client: {p.client || 'Internal'}</p>
              
              <div style={{ display: 'flex', gap: 16, marginTop: 20, paddingTop: 16, borderTop: '1px solid #f0f0f0' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#555' }}>
                  <Users size={16} color={TOKENS.gold} /> Team
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#555' }}>
                  <CheckSquare size={16} color={TOKENS.gold} /> Tasks
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
